/**
 * Chooses crop/resize output encoding from the source file type.
 * JPEG stays JPEG (smaller photos). Anything else, including PNG/WebP/GIF,
 * is encoded as PNG so the alpha channel is preserved.
 */
export function outputMimeFor(sourceType: string | undefined | null): {
  mimeType: 'image/jpeg' | 'image/png';
  filename: 'cropped-image.jpg' | 'cropped-image.png';
} {
  const normalized = (sourceType ?? '').toLowerCase();
  if (normalized === 'image/jpeg' || normalized === 'image/jpg') {
    return { mimeType: 'image/jpeg', filename: 'cropped-image.jpg' };
  }
  return { mimeType: 'image/png', filename: 'cropped-image.png' };
}
